import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("circle", {
  cx: "9",
  cy: "10",
  r: "2",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M14.48 18.34C13.29 17.73 11.37 17 9 17c-2.37 0-4.29.73-5.48 1.34-.62.32-.52.94-.52 1.66h12c0-.71.11-1.34-.52-1.66z",
  opacity: ".3"
}, "1"), /*#__PURE__*/_jsx("path", {
  d: "M21 3H3c-1.1 0-2 .9-2 2v8h2V5h18v16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}, "2"), /*#__PURE__*/_jsx("path", {
  d: "M13 10c0-2.21-1.79-4-4-4s-4 1.79-4 4 1.79 4 4 4 4-1.79 4-4zm-6 0c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm8.39 6.56C13.71 15.7 11.53 15 9 15s-4.71.7-6.39 1.56C1.61 17.07 1 18.1 1 19.22V22h16v-2.78c0-1.12-.61-2.15-1.61-2.66zM15 20H3c0-.72-.1-1.34.52-1.66C4.71 17.73 6.63 17 9 17c2.37 0 4.29.73 5.48 1.34.63.32.52.95.52 1.66z"
}, "3")], 'CoPresentTwoTone');